import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';

import { isEmptyActiveAnnouncementsSelector } from 'selectors/index';
import { fetchAnnouncements } from 'dashboard/actions/announcements/announcements.actions';

import template from './announcements-widget.html';

const mapStateToThis = (state) => {
  const { config, announcements } = state;
  const { jurisdictionId } = config;
  const { isLoading, active } = announcements;

  return {
    jurisdictionId,
    isLoading,
    active,
    isEmpty: isEmptyActiveAnnouncementsSelector(state),
  };
};

const mapDispatchToThis = {
  fetchAnnouncements,
};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux')
class AnnouncementsWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.$scope.$applyAsync(this.fetchAnnouncements(true));
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class AnnouncementsWidgetComponent {
  constructor() {
    this.template = template;
    this.controller = AnnouncementsWidgetController;
    this.bindings = {
      isEditMode: '<',
      isDisabledShare: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/announcements/announcements-widget-component.js